
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "updateNoteComment",
      resolverType: "mutation",
      routePath: "/updateNoteComment",
      httpMethod: "POST",
    });
  